var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { VatRateTypeSetting } from "./VatRateTypeSetting";
export class SearchResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "TotalCount");
    /**
     */
    __publicField(this, "VatRateTypeSettings");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchResult
     */
    __publicField(this, "$type", "V1.VatRateTypes.Search.SearchResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.TotalCount = _data["TotalCount"];
      if (_data["VatRateTypeSettings"] && _data["VatRateTypeSettings"].constructor === Array) {
        this.VatRateTypeSettings = [];
        for (let item of _data["VatRateTypeSettings"]) {
          const vatRateTypeSettings_ = new VatRateTypeSetting();
          this.VatRateTypeSettings.push(vatRateTypeSettings_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["TotalCount"] = this.TotalCount;
    if (this.VatRateTypeSettings && this.VatRateTypeSettings.constructor === Array) {
      _data["VatRateTypeSettings"] = [];
      for (let item of this.VatRateTypeSettings) {
        _data["VatRateTypeSettings"].push(item.toJSON());
      }
    }
    return _data;
  }
}
